import ExistingCampaignPrompt from "./ExistingCampaignPrompt";
import { ExistingCampaignPromptPropsT } from "./models";

import styles from "./existingCampaignPrompt.module.scss";

/**
 * Popup config for usePopup().createPopup(). No `header` / `footer`: the body renders its own title
 * (it changes between the default and the confirm step) and its buttons sit next to the content.
 */
export default (props: ExistingCampaignPromptPropsT) => ({
  body: <ExistingCampaignPrompt {...props} />,
  className: styles.popup,
});
